/**
 * État de chaque étape du parcours d'ÉVALUATION, tel que l'affiche `EvalPhaseSteps`.
 *
 * - `done` : étape terminée (une session jouée suffit, cf. migration `20260730-1919`) ;
 * - `current` : la PREMIÈRE étape ouverte et non terminée — c'est elle que l'écran met en avant ;
 * - `open` : une autre étape ouverte et non terminée (ordre de déblocage personnalisé) ;
 * - `upcoming` : pas encore ouverte — l'écran dit après quelle étape elle s'ouvre,
 *   jamais « Verrouillé ».
 *
 * Pure (client + serveur, testable sans base).
 */
export type EvalStepState = "done" | "current" | "open" | "upcoming";

export function evalStepStates(phases: Array<{ accessible?: boolean; progress?: { status?: string | null } | null }>): EvalStepState[] {
  let currentTaken = false;
  return phases.map((ph) => {
    if ((ph.progress?.status || "todo") === "done") return "done";
    if (!ph.accessible) return "upcoming";
    if (currentTaken) return "open";
    currentTaken = true;
    return "current";
  });
}
